import request from '@/utils/request'
import qs from 'qs'

export function saveoModeSetting(data){
  return request({
    url: '/wwqb/exam-paper/answer-mode/edit',
    method: 'post',
    data: data
  })
}
export function saveoRefiningModeSetting(data){
  return request({
    url: '/stage4/wwqb/exam-paper/answer-mode/edit',
    method: 'post',
    data: data
  })
}

export function getModeSetting(data){
  let urlStr = '/wwqb/exam-paper/answer-mode/get?'+ 'regionId=' + data.regionId + '&bookId=' + data.bookId + '&catalogType=' + data.catalogType
  if(data.scope){
    urlStr += '&scope=' + data.scope
  }
  return request({
    url: urlStr,
    method: 'get',
  })
}

export function getRefiningModeSetting(data){
  return request({
    url: '/stage4/wwqb/exam-paper/answer-mode/get?'+qs.stringify(data, { encode: false }),
    method: 'get'
  })
}

export function getTopListById(data){
  return request({
    url: '/wwqb/exam-paper/detail?id=' + data.coilingId,
    method: 'get',
  })
}

export function saveProgressBatch(data){
  return request({
    url: '/wwqb/exam-paper/progress/edit',
    method: 'post',
    data: data
  })
}
export function saveProgressBatch4(data){
  return request({
    url: '/stage4/wwqb/exam-paper/progress/edit',
    method: 'post',
    data: data
  })
}